<mat-card appearance="outlined" style="margin-bottom: 1em; margin-top: 1em">
    <mat-card-content>
    <form [formGroup]="form">
        <div class="editFeature">
            <div class="left-feature-column">
                <div class="feature-settings">
                    <mat-form-field><input matInput name="featureName" placeholder="Name"
                            formControlName="commonFeatureName" required />
                        <mat-error *ngIf="isFeatureNameInvalid()">
                            Der Name muss ausgefüllt sein.
                        </mat-error>
                        <mat-error *ngIf="areEntriesInvalid()">
                            Es muss mindestens eine Auswahlmöglichkeit vorhanden
                            sein.
                        </mat-error>
                    </mat-form-field>
                    <mat-checkbox labelPosition="before" formControlName="filterOption">Filter Option</mat-checkbox>
                    <mat-checkbox labelPosition="before" formControlName="showDetailPage">
                        Anzeige auf Produktdetailseite
                    </mat-checkbox>
                    <div>
                        <p>Verknüpfungsmethode:</p>
                        <mat-radio-group formControlName="linkingMethod" class="radio-group">
                            <mat-radio-button *ngFor="let method of linkingMethods" [value]="method">
                                {{
                                getLocalizedLinkingMethodButtonText(method)
                                }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div formArrayName="appKategorie">
                        <p>Filter Pannel Kategorie:</p>
                        <div *ngFor="let category of categories; let i = index">
                            <mat-checkbox [formControlName]="i">
                                {{ category.name }}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="button-panel">
                    <button matButton="elevated" color="warn" (click)="cancel()">
                        Abbrechen
                    </button>
                    <button matButton="elevated" class="green-confirm" [disabled]="form.invalid" (click)="save()">
                        Speichern
                    </button>
                    <button matButton="elevated" color="warn" (click)="delete()" *ngIf="commonFeature.id != null">
                        Löschen
                    </button>
                </div>
            </div>

            <div formArrayName="entries">
                <div *ngFor="let entry of entries.controls; let i = index" class="featureEntry">
                    <div [formGroupName]="i">
                        <mat-form-field>
                            <mat-label>
                                Auswahlmöglichkeit {{ i + 1 }}
                            </mat-label>
                            <input matInput formControlName="name" required />
                            <mat-error *ngIf="isEntryInvalid(i)">
                                Auswahlmöglichkeit darf nicht leer sein.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <button class="remove-entry-button" color="warn" matButton="elevated" (click)="removeFeatureEntry(i)">
                        X
                    </button>
                </div>
                <div class="featureEntry">
                    <button class="add-entry-button" color="accent" matButton="elevated" (click)="addFeatureEntry()">
                        Auswahlmöglichkeit hinzufügen
                    </button>
                </div>
            </div>
        </div>
    </form>
    </mat-card-content>
</mat-card>